/* eslint-disable */
<template>
    <i-page-shell :side-nav-items="[
    {
      label: 'RHC Program Tools',
      heading: true
    },
    {
      label: 'Rurality Tier Search Tool',
      href: '#/',
      active: true
    },
    {
      label: 'Rates Database',
      href: '#/ratesSearch'
    }
  ]" header-title="Rural Health Care Program Tools">
        <template v-slot:app-footer>
            <i-app-footer :legal-links="[ {
          text: 'Version ' + appversion
        }]"/>
        </template>

        <i-grid></i-grid>
        <i-form id="ruralitySearchForm">
            <i-modal header="HCP/Site Address"
                     @on-primary-button-click="closeModal"
                     ref="checkModal"
                     body="Enter either your address or geographic coordinates but NOT both to find your rurality tier."
                     primary-button-label="OK"/>
            <i-long-form-text>
                <h1 id="page-title" tabindex='0'>Rurality Tier Search Tool</h1>

                <p id="help-text">
                    Enter your address or geographic coordinates below to find your rurality tier, MUA/P status, and priority. For more
                    information about rurality tiers and terms used in the search results, please visit the
                    <span>
                            <a id="help-link" target="_blank" :href="ruralityToolHelplink" aria-labelledby="help-text">Rurality Tier Search Tool homepage.
                        </a>
                        </span>
                </p>
            </i-long-form-text>

            <i-notification id="nomatchruralitybyaddress-error" variant="error" v-if="nomatchruralitybyaddress"
                            message="We are unable to determine the rurality tier based on the address entered. If you continue to receive this error please email RHC-Assist@usac.org for assistance."/>
            <i-notification id="nomatchruralitybycoordinates-error" variant="error" v-if="nomatchruralitybycoordinates"
                            message="We are unable to determine the rurality tier based on the latitude and longitude entered. If you continue to receive this error please email rhc-assist@usac.org for assistance"/>
            <i-notification id="nomatchaddress-error" variant="error" v-if="nomatchaddress"
                            message="We were unable to standardize this address using USPS. Please try another format. If you continue to receive this error, please check our FAQ or email RHC-Assist@usac.org for assistance."/>
            <i-notification id="servicedown-error" variant="error" v-if="servicedown"
                            message="This search tool is currently unavailable. We apologize for the inconvenience, please try again later."/>


            <i-fieldset legend="HCP/Site Address" legendLevel="h2">
                <i-grid>
                    <i-input-group id="address-street" class="indi-col-xs-8" label="Street Address"
                                   label-for="street-input"
                                   :notification-text="street.errorMessage" :invalid="street.invalid">
                        <i-input :maxlength="100" :invalid="street.invalid"
                                 v-model="street.value"
                                 aria-labelledby="address-street" id="street-input"/>
                    </i-input-group>

                    <i-input-group id="address-apt" class="indi-col-xs-4">
                        <i-label text="Apt, Unit, etc" input-for="apt-input">
                                <span slot="annotation" style="color: #717171;"
                                      class="indi-form__label-optional-indicator">(Optional)</span>
                        </i-label>
                        <i-input :maxlength="50" v-model="apt" id="apt-input"
                                 aria-labelledby="address-apt"/>
                    </i-input-group>


                    <i-input-group id="address-city" class="indi-col-xs-5" label="City" label-for="city-input"
                                   :notification-text="city.errorMessage"
                                   :invalid="city.invalid">
                        <i-input :maxlength="50" v-model="city.value"
                                 :invalid="city.invalid" id="city-input"
                                 aria-labelledby="address-city"/>
                    </i-input-group>
                    <i-input-group class="indi-col-xs-3" id="address-state" label="State"
                                   :invalid="state.invalid"
                                   :notification-text="state.errorMessage"
                                   label-for="state-input">
                        <i-select :required="false" v-model="state.value" id="state-input"
                                  :invalid="state.invalid"
                                  aria-labelledby="address-state" :options="allStates"/>
                    </i-input-group>
                    <i-input-group class="indi-col-xs-4" id="address-zip" label="ZIP Code" label-for="zip-input"
                                   :notification-text="zip.errorMessage"
                                   :invalid="zip.invalid">
                        <i-input :invalid="zip.invalid" v-model="zip.value" id="zip-input"
                                 aria-labelledby="address-zip"/>
                    </i-input-group>
                </i-grid>

                <i-grid>
                    <i-input-group class="indi-col-xs-12">

                        <h3 style="color: #0052EB;cursor: pointer;" tabindex="0"  @click="toggleInput" @keydown.space="toggleInput" id="search-by-coordinates-btn">
                            Search with geographic coordinates(latitude-longitude) instead.
                            <i-icon valign="valign-middle">
                                <IconCaretUp v-if="byCoordinates"/>
                                <IconCaretDown v-else/>
                            </i-icon>
                        </h3>
                    </i-input-group>
                    <i-input-group v-if="byCoordinates" class="indi-col-xs-4" id="latitude" label="Latitude"
                                   label-for="latitude-input"
                                   :notification-text="latitude.errorMessage"
                                   :invalid="latitude.invalid">
                        <i-input @keyup="numericOnly" :invalid="latitude.invalid" v-model="latitude.value"
                                 id="latitude-input"/>
                    </i-input-group>
                    <i-input-group v-if="byCoordinates" class="indi-col-xs-4" id="longitude" label="Longitude"
                                   label-for="longitude-input"
                                   :notification-text="longitude.errorMessage"
                                   :invalid="longitude.invalid">
                        <i-input @keyup="numericOnly" :invalid="longitude.invalid" v-model="longitude.value"
                                 id="longitude-input"
                        />
                    </i-input-group>
                </i-grid>

            </i-fieldset>
            <div id="submit-button" style="margin-bottom: 0px">
                <i-input-group class="indi-col-lg-12 indi-form__input-group--text-align-right">
                    <i-button type="button" @click="search" label="Search"
                              variant="primary"/>
                </i-input-group>
            </div>


            <i-grid>
                <div class="indi-col-xs-12" style="padding-bottom:16px;padding-top:42px;margin-top:0px"
                     v-if="searchcomplete && !nomatchruralitybyaddress && !nomatchruralitybycoordinates && !nomatchaddress && !servicedown">
                    <i-grid>
                        <i-long-form-text class="indi-col-xs-12" style="margin-bottom: 0px; padding-bottom: 16px;">
                            <h3 id="tier-info-title">Your Rurality Tier Information:</h3>
                            <i-notification id="warning-state-mismatch" variant="warning"
                                            style="margin-bottom: 0px;width:709px;"
                                            v-if="statemismatch"
                                            message="This Rurality Tier was calculated based on the Street Address, City, and Zip Code entered. The state you selected does not match the other fields."/>
                        </i-long-form-text>
                        <i-long-form-text class="indi-col-xs-12">
                            <div style="border: solid 1px #ffab00; width:766px;"
                                 aria-labelledby="tier-info-title">
                                <i-grid>
                                    <p id="tier-label" class="indi-col-xs-6"
                                       style="text-align: right;margin-top:16px;margin-bottom:0px;">Rurality
                                        Tier:</p>
                                    <p id="tier" class="indi-col-xs-3"
                                       style="font-weight: bold;margin-top:16px;margin-bottom:0px;">
                                        {{rurality_tier}}</p>
                                    <p id="muap-label" class="indi-col-xs-6"
                                       style="text-align: right;margin-top:16px;margin-bottom:0px;">Medically
                                        Underserved
                                        Area/Population (MUA/P):</p>
                                    <p id="muap" class="indi-col-xs-3"
                                       style="font-weight: bold;margin-top:16px;margin-bottom:0px;">{{muap}}</p>
                                    <p id="priority-label" class="indi-col-xs-6"
                                       style="text-align: right;margin-top:16px;">Priority:</p>
                                    <p id="priority" class="indi-col-xs-3"
                                       style="font-weight: bold;margin-top:16px;">Priority
                                        {{rural_priority}}</p>
                                </i-grid>
                            </div>
                            <i-input-group style="padding-top:72px;"
                                           class="indi-col-xs-12 indi-form__input-group--text-align-right">
                                <h4 id="link-rates-prepopulated">
                                    <router-link v-if="!byCoordinates && state.value"
                                                 style="text-decoration: none; color: #0052EB;"
                                                 :to="{ name: 'ratesSearch', params: { selected_ruralityTier: rurality_tier, selected_state: state.value } }">
                                        Calculate the median rate for my location
                                    </router-link>
                                </h4>
                                <h4 id="link-rates">
                                    <router-link style="text-decoration: none;color: #0052EB;"
                                                 v-if="byCoordinates || !state.value"
                                                 :to="{ name: 'ratesSearch', params: { selected_ruralityTier: rurality_tier} }">
                                        Calculate the median rate for my location
                                    </router-link>
                                </h4>
                            </i-input-group>
                        </i-long-form-text>
                    </i-grid>
                </div>
            </i-grid>

            <div id="loader">
                <i-loader v-if="loading" variant="overlay"/>
            </div>
        </i-form>
    </i-page-shell>
</template>
<style>
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
</style>
<script>
    document.title = "Rurality Tier Search Tool";
    import {
        IAppFooter,
        IButton,
        ICheckbox,
        IFieldset,
        IForm,
        IGrid,
        IIcon,
        IInput,
        IInputGroup,
        ILabel,
        ILoader,
        ILongFormText,
        IModal,
        INotification,
        IPageShell,
        ISelect
    } from 'indigo-component-library';
    import axios from "axios";
    import {setFocusOnError} from "../assets/data-service";
    import {IconCaretDown,IconCaretUp} from 'indigo-component-library/src/components/Icon/Icons';

    export default {
        name: "RuralitySearch",
        components: {
            IGrid,
            IForm,
            ILoader,
            IInput,
            IButton,
            IFieldset,
            IInputGroup,
            ISelect,
            ILongFormText,
            INotification,
            IPageShell,
            IAppFooter,
            ILabel,
            ICheckbox,
            IIcon,
            IconCaretDown,
            IconCaretUp,
            IModal
        },
        data() {
            return {
                ruralityToolHelplink: '',
                appversion: this.$store.getters.appVersion,
                byCoordinates: false,
                latitude: {
                    value: '',
                    invalid: false,
                    errorMessage: ''
                },
                longitude: {
                    value: '',
                    invalid: false,
                    errorMessage: ''
                },
                street: {
                    value: '',
                    invalid: false,
                    errorMessage: ''
                },
                apt: '',
                city: {
                    value: '',
                    invalid: false,
                    errorMessage: ''
                },
                state: {
                    label: '',
                    value: '',
                    invalid: false,
                    errorMessage: ''
                },
                zip: {
                    value: '',
                    invalid: false,
                    errorMessage: ''
                },
                rurality_tier: '',
                rural_priority: '',
                muap: '',
                loading: false,
                searchcomplete: false,
                nomatchruralitybyaddress: false,
                nomatchruralitybycoordinates: false,
                nomatchaddress: false,
                servicedown: false,
                statemismatch: false,
                allStates: []
            }
        },
        methods: {
            toggleInput() {
                if (this.byCoordinates) {
                    this.byCoordinates = false;
                } else {
                    this.byCoordinates = true;
                }
            },
            numericOnly(e) {
                e.target.value = e.target.value.replace(/[^-0-9/.]/g, "");
            },
             pullSystemProperties() {
                axios.get('/ratesdb/systemProperties').then(response => {
                    if (response.data != undefined && response.data.length > 0) {
                        for (let i = 0; i < response.data.length; i++) {
                            if (response.data[i].name == 'ruralityToolHelpLink') {
                                this.ruralityToolHelplink = response.data[i].value;
                            }

                        }
                    }
                });
            },
            pullAllStates() {
                axios.get('/ratesdb/states').then(response => {
                    this.allStates.push({
                        label: '',
                        value: ''
                    });
                    response.data.forEach(st => {
                            this.allStates.push({
                                label: st,
                                value: st
                            });
                        }
                    );
                });
            },
            searchRuralityByAddress() {
                if (this.street.value.trim().length === 0) {
                    this.street.invalid = true;
                    this.street.errorMessage = 'Street Address is required';
                } else {
                    this.street.invalid = false;
                    this.street.errorMessage = '';
                }
                if (this.city.value.trim().length === 0) {
                    this.city.invalid = true;
                    this.city.errorMessage = 'City is required';
                } else {
                    this.city.invalid = false;
                    this.city.errorMessage = '';
                }
                if (this.state.value.length === 0) {
                    this.state.invalid = true;
                    this.state.errorMessage = 'State is required';
                } else {
                    this.state.invalid = false;
                    this.state.errorMessage = '';
                }

                let isValidZipCode = validateZipCode(this.zip.value.trim());
                if (this.zip.value.trim().length === 0) {
                    this.zip.invalid = true;
                    this.zip.errorMessage = 'Zip code is required';
                } else if (!isValidZipCode) {
                    this.zip.invalid = true;
                    this.zip.errorMessage = 'Use standard format ##### or #####-####';
                } else {
                    this.zip.invalid = false;
                    this.zip.errorMessage = '';
                }
                if (!this.street.invalid && !this.zip.invalid && !this.city.invalid && !this.state.invalid) {
                    this.loading = true;
                    axios.get('/ratesdb/ruralityInfoByAddress', {
                        params: {
                            address: {
                                "addressLine1": this.street.value + " " + this.apt,
                                "city": this.city.value,
                                "state": this.state.value,
                                "zip": this.zip.value
                            }
                        }
                    }).then(response => {
                        switch (response.data.status) {
                            case 'OK':
                                this.rurality_tier = response.data.ruralTierText;
                                this.rural_priority = response.data.ruralPriority;
                                this.muap = response.data.muap;
                                this.nomatchruralitybyaddress = false;
                                this.nomatchruralitybycoordinates = false;
                                this.nomatchaddress = false;
                                this.servicedown = false;
                                this.statemismatch = false;
                                break;
                            case 'STATE_MISMATCH':
                                this.rurality_tier = response.data.ruralTierText;
                                this.rural_priority = response.data.ruralPriority;
                                this.muap = response.data.muap;
                                this.nomatchruralitybyaddress = false;
                                this.nomatchruralitybycoordinates = false;
                                this.nomatchaddress = false;
                                this.servicedown = false;
                                this.statemismatch = true;
                                break;
                            case 'NO_MATCHED_ADDRESS':
                                this.nomatchruralitybyaddress = false;
                                this.nomatchruralitybycoordinates = false;
                                this.nomatchaddress = true;
                                this.servicedown = false;
                                break;
                            case 'NO_RURALITY_RESULT':
                                this.nomatchruralitybyaddress = true;
                                this.nomatchruralitybycoordinates = false;
                                this.nomatchaddress = false;
                                this.servicedown = false;
                                break;
                            default:
                                this.nomatchruralitybyaddress = false;
                                this.nomatchruralitybycoordinates = false;
                                this.nomatchaddress = false;
                                this.servicedown = true;
                        }
                        this.loading = false;
                        this.searchcomplete = true;
                    }).catch(error => {
                        console.log("error", error.message);
                        this.nomatchruralitybyaddress = false;
                        this.nomatchruralitybycoordinates = false;
                        this.nomatchaddress = false;
                        this.servicedown = true;
                        this.loading = false;
                        this.searchcomplete = true;
                    });
                } else {
                    let fields = new Map();
                    fields.set("street-input", this.street.invalid);
                    fields.set("city-input", this.city.invalid);
                    fields.set("state-input", this.state.invalid);
                    fields.set("zip-input", this.zip.invalid);

                    // for (let[id, invalid] of fields) {
                    //     console.log("validateForm. (id ="+ id +";  invalid = " + invalid);
                    //   }

                    setFocusOnError(fields);
                }

            },
            closeModal() {
                this.$refs.checkModal.toggleOpen();
            },
            search() {
                console.log(this.longitude.value);
                this.latitude.invalid = false;
                this.longitude.invalid = false;
                this.latitude.errorMessage = '';
                this.longitude.errorMessage = '';
                this.street.invalid = false;
                this.street.errorMessage = '';
                this.city.invalid = false;
                this.city.errorMessage = '';
                this.state.invalid = false;
                this.state.errorMessage = '';
                this.zip.invalid = false;
                this.zip.errorMessage = '';
                this.nomatchruralitybyaddress = false;
                this.nomatchruralitybycoordinates = false;
                this.nomatchaddress = false;
                this.servicedown = false;
                this.statemismatch = false;
                this.searchcomplete = false;
                if ((this.street.value.trim().length > 0 ||
                    this.apt.trim().length > 0 ||
                    this.city.value.trim().length > 0 ||
                    this.state.value.trim().length > 0 ||
                    this.zip.value.trim().length > 0) &&
                    (this.latitude.value.trim().length > 0 ||
                        this.longitude.value.trim().length > 0)
                    /* User entered both address and coordinates */
                ) {
                    this.$refs.checkModal.toggleOpen();
                } else if (this.latitude.value.trim().length > 0 ||
                    this.longitude.value.trim().length > 0 ||
                    (this.byCoordinates &&
                        this.street.value.trim().length == 0 &&
                        this.apt.trim().length == 0 &&
                        this.city.value.trim().length == 0 &&
                        this.state.value.trim().length == 0 &&
                        this.zip.value.trim().length == 0)) {
                    this.searchRuralityByCoordinates();
                } else {
                    this.searchRuralityByAddress();
                }
            },
            searchRuralityByCoordinates() {
                this.byCoordinates = true;
                if (this.latitude.value.trim().length == 0) {
                    this.latitude.invalid = true;
                    this.latitude.errorMessage = 'Latitude is required.';
                } else if (isNaN(this.latitude.value) || this.latitude.value > 90 || this.latitude.value < -90) {
                    this.latitude.invalid = true;
                    this.latitude.errorMessage = 'Enter a valid latitude.';
                } else if (countDecimals(this.latitude.value) < 5) {
                    this.latitude.invalid = true;
                    this.latitude.errorMessage = 'Enter at least 5 numbers after the decimal.';
                } else if (countDecimals(this.latitude.value) > 13) {
                    this.latitude.invalid = true;
                    this.latitude.errorMessage = 'Enter no more than 13 numbers after the decimal.';
                } else {
                    this.latitude.invalid = false;
                    this.latitude.errorMessage = '';
                }
                if (this.longitude.value.trim().length == 0) {
                    this.longitude.invalid = true;
                    this.longitude.errorMessage = 'Longitude is required.';
                } else if (isNaN(this.longitude.value) || this.longitude.value > 180 || this.longitude.value < -180) {
                    this.longitude.invalid = true;
                    this.longitude.errorMessage = 'Enter a valid longitude.';
                } else if (countDecimals(this.longitude.value) < 5) {
                    this.longitude.invalid = true;
                    this.longitude.errorMessage = 'Enter at least 5 numbers after the decimal.';
                } else if (countDecimals(this.longitude.value) > 13) {
                    this.longitude.invalid = true;
                    this.longitude.errorMessage = 'Enter no more than 13 numbers after the decimal.';
                } else {
                    this.longitude.invalid = false;
                    this.longitude.errorMessage = '';
                }
                if (!this.longitude.invalid && !this.latitude.invalid) {
                    this.loading = true;
                    axios.get('/ratesdb/ruralityInfoByCoordinates', {
                        params: {
                            "latitude": this.latitude.value,
                            "longitude": this.longitude.value
                        }
                    }).then(response => {
                        console.log(response.data);
                        switch (response.data.status) {
                            case "OK":
                                this.rurality_tier = response.data.ruralTierText;
                                this.rural_priority = response.data.ruralPriority;
                                this.muap = response.data.muap;
                                this.nomatchruralitybyaddress = false;
                                this.nomatchruralitybycoordinates = false;
                                this.nomatchaddress = false;
                                this.servicedown = false;
                                this.statemismatch = false;
                                break;
                            case 'NO_RURALITY_RESULT':
                                this.nomatchruralitybycoordinates = true;
                                this.nomatchruralitybyaddress = false;
                                this.nomatchaddress = false;
                                this.servicedown = false;
                                break;
                            default:
                                this.nomatchruralitybyaddress = false;
                                this.nomatchruralitybycoordinates = false;
                                this.nomatchaddress = false;
                                this.servicedown = true;
                        }
                        this.loading = false;
                        this.searchcomplete = true;
                    }).catch(error => {
                        console.log("error", error.message);
                        this.nomatchruralitybycoordinates = false;
                        this.nomatchruralitybyaddress = false;
                        this.nomatchaddress = false;
                        this.servicedown = true;
                        this.loading = false;
                        this.searchcomplete = true;
                    });

                }
            }
        },
        mounted() {
            this.pullAllStates();
            this.pullSystemProperties();
        },
    }

    function validateZipCode(elementValue) {
        let zipCodePattern = /^\d{5}$|^\d{5}-\d{4}$/;
        return zipCodePattern.test(elementValue);
    }

    let countDecimals = function (value) {
        if (Math.floor(value) == value) return 0;
        return value.toString().split(".")[1].length || 0;
    }




</script>
